export default "__VITE_ASSET__D4Zy932p__"